import callApi from 'services/api'

export const getMasterdata = async (id) => {
  try {
    const response = await callApi(
      `filtermaster/${id}`,
      'GET',
      null,
      true,
      true
    )

    if (response.success) {
      // Case 1: data is wrapped inside body.data
      if (response?.body?.data) {
        return response.body.data
      }

      // Case 2: data is directly inside body
      if (response?.body) {
        return response.body
      }
    }

    return null
  } catch (err) {
    console.error('Error fetching masterdata:', err)
    return null
  }
}

export const getMasterdataNames = async (id) => {
  try {
    const response = await callApi(
      `filtermaster/${id}`,
      'GET',
      null,
      true,
      true
    )

    if (response.success) {
      // Case 1: data is wrapped inside body.data
      if (response?.body?.data) {
        return response.body.data
      }

      // Case 2: data is directly inside body
      if (response?.body) {
        return response?.body?.name
      }
    }

    return null
  } catch (err) {
    console.error('Error fetching masterdata:', err)
    return null
  }
}

export const getList = async (value) => {
  try {
    const params = new URLSearchParams({
      filter: JSON.stringify({ type: value }),
      sort_order: '1',
      sort_by: 'name',
      page: '1',
      limit: '1000',
    })

    const response = await callApi(
      `filtermaster?${params}`,
      'GET',
      null,
      true,
      true,
      (path) => console.log('navigate to', path)
    )

    if (response.success) {
      return response.body.data
    }
  } catch (error) { }
}
